import {Injectable} from '@angular/core';
import {CashierContentService} from 'src/app/services/cashier/cashier-content.service';
import {CashierService} from 'src/app/services/cashier/cashier.service';
import {Navigator} from 'src/app/services/routing/navigator';
import {UtilsService} from '../utils/utils.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class OnDepositService {
  constructor(
    private navigator: Navigator,
    private utils: UtilsService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    private platform: Platform
  ) {}
  deposit(campaignId) {
    return this.cashierService
      .getActiveTypesCategories({include_types: false})
      .subscribe({
        next: (response: any) => {
          if (response) {
            const navParams: any = {};
            const data = response.payload.filter(
              item => item.is_default == true
            );
            let lastDeposit = data.length > 0 ? data[0].code : null;
            //Apple Pay is only supported on iOS app
            if(lastDeposit == "VVAP" && !(this.platform.is('capacitor') && this.platform.is('ios'))) {
              lastDeposit = null;
            }
            const pageToRedirect =
              this.cashierContentService.getVendorPage(lastDeposit);
            const recievedSelectedBonus =
              this.cashierContentService.getSelectedBonus();
            if (campaignId) {
              this.utils.setCampaignId(campaignId);
              this.cashierContentService.setSelectBestOne(false);
              navParams.bonusCode = campaignId;
            } else {
              if (recievedSelectedBonus) {
                this.cashierContentService.setSelectBestOne(true);
                navParams.bonusCode = recievedSelectedBonus.offer.campaign_code;
              }
            }
            this.cashierContentService.updateBonusOfferValue(navParams.bonusCode);
            pageToRedirect
              ? this.navigator.navigateTo(
                  pageToRedirect,
                  {multipleModals: true},
                  navParams
                )
              : this.navigator.navigateTo(
                  'DepositMainComponent',
                  {multipleModals: true},
                  navParams
                );
          }
        },
        error: error => this.navigator.navigateTo('DepositMainComponent')
      });
  }
}
